import { Form } from 'antd';
import { FC } from 'react';
import { Relatie } from '@/lib/types';
import { getManualInputVersion, ManualInputVersion } from './manual-input-version';
import { SubstraatteeltMilieugegevensV1 } from './v1/substraatteelt-milieugegevens-v1';
import { SubstraatteeltMilieugegevensV2 } from './v2/substraatteelt-milieugegevens-v2';
import { SubstraatteeltMilieugegevensV3 } from './v3/substraatteelt-milieugegevens-v3';

const milieugegevensByVersion: Record<ManualInputVersion, FC> = {
  v1: SubstraatteeltMilieugegevensV1,
  v2: SubstraatteeltMilieugegevensV2,
  v3: SubstraatteeltMilieugegevensV3,
};

export const SubstraatteeltMiliegegevens: FC = () => {
  const form = Form.useFormInstance<Relatie>();
  const registratiejaar = form.getFieldValue('registratiejaar');
  const version = getManualInputVersion(registratiejaar);
  const Milieugegevens = version ? milieugegevensByVersion[version] : undefined;

  return Milieugegevens ? <Milieugegevens /> : null;
};
